<label class="textarea">
  <p *ngIf="title" class="title">
    {{title}}
  </p>
  <textarea class="field"
            [placeholder]="placeholder"
            [ngModel]="value"
            [disabled]="disabled"
            rows="4"
            (blur)="onTouch($event)"
            [(ngModel)]="value"
            (ngModelChange)="onModelChange($event)">
  </textarea>
  <span *ngIf="value && clearable" class="clear" (click)="onClear()">
    ×
  </span>
</label>
